import React from 'react';
import './index.scss';

const CheckBoxInput = ({ value, onChange, checked, label }) => {
  return (
    <div className="CheckBoxInput">
      <input
        type="checkbox"
        value={value}
        onChange={onChange}
        checked={checked}
      />
      <label>
        <div>{label}</div>
      </label>
    </div>
  );
};

export default CheckBoxInput;